<!-- Search Filter - Debounced search input for agents -->
<div class="search-filter-container">
  <div class="search-input-wrapper">
    
    <!-- Search Icon -->
    <span class="search-icon" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>

    <!-- Search Input -->
    <input
      type="text"
      class="search-input"
      [placeholder]="placeholder"
      [value]="searchQuery"
      (input)="onInputChange($event)"
      (keydown)="onKeyDown($event)"
      aria-label="Search agents"
      autocomplete="off"
      spellcheck="false">

    <!-- Clear Button -->
    <button
      *ngIf="hasValue"
      class="clear-button"
      (click)="clearSearch()"
      type="button"
      aria-label="Clear search">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

  </div>
</div>
